import React, { useEffect, useRef, useState } from 'react'
import { useIntl } from 'react-intl'
import Tooltip from 'rc-tooltip'
import 'rc-tooltip/assets/bootstrap_white.css'
import { Card } from '../../../components/Card'
import { CloseBtn } from '../../../components/CloseBtn'
import { ModalProvider } from '../../../helpers/ModalContext'
import FormattedMessage from '../../../helpers/FormattedMessage'
import { schoolCloth, printColors } from '../../../setups/setups'
import { useModal } from '../../../components/Modal'
import { FileInput } from '../../../components/FileInput'
import { TopSection } from '../../../components/TopSection'
import { Prompt } from '../../../components/Prompt'
import { Select } from '../../../components/Select'
import { logoStaticContent, designOptionsStaticContent } from '../../../components/ModalStatic'
import styles from './Step4.module.scss'
import { Button } from 'src/components/Button'
import { InputButton } from 'src/components/InputButton'
import { sendFiles } from '../../../helpers/sendFiles'
import { CustomInput } from 'src/components/CustomInput'

interface IProps {
  nextStep: () => void
  cancel: () => void
}

export type CardType = {
  clothType: string
  color: string
  design: string
  logos: {
    url: string
    name: string
  }[]
  otherLogoColor: boolean
  logoColor: string
  priceMargin: number
}

export const Step4 = ({ nextStep, cancel }: IProps) => {
  const intl = useIntl()
  const { Modal, openModal, closeModal } = useModal()
  const [color, setColor] = useState(window.localStorage.getItem('School-color') || '')
  const [noLogoPrompt, setNoLogoPrompt] = useState(window.localStorage.getItem('School-noLogoPrompt') || '')
  const [design, setDesign] = useState('')
  const [logoColor, setLogoColor] = useState('')
  const [logoFiles, setLogoFiles] = useState([])
  const [cancelPrompt, setCancelPrompt] = useState(false)
  const [withoutLogo, setWithoutLogo] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [priceMargin, setpriceMargin] = useState(-1)
  const clothType = window.localStorage.getItem('School-clothType') || ''
  const [isError, setIsError] = useState(false)
  const visibleCard = useRef(1)
  const [openContent, setOpenContent] = useState(1)
  const [otherLogoColor, setOtherLogoColor] = useState(false)

  useEffect(() => {
    window.localStorage.setItem('School-step', '4')
  }, [])

  const saveData = (urls: string[]) => {
    const item: CardType = {
      color,
      clothType,
      design,
      logoColor,
      otherLogoColor,
      priceMargin: priceMargin >= 0 ? priceMargin : 0,
      logos: urls.map((item, index) => {
        return {
          url: item,
          // @ts-ignore
          name: logoFiles[index].path
        }
      }),
    }

    const savedItems = JSON.parse(window.localStorage.getItem('School-savedItems') || '[]')
    savedItems.push(item)
    window.localStorage.setItem('School-savedItems', JSON.stringify(savedItems))
    nextStep()
  }

  const setDesignValue = (design: string) => {
    setIsError(false)
    setDesign(design)
    closeModal()
  }

  const setLogoColorValue = (color: string) => {
    setIsError(false)
    setLogoColor(color)
  }

  const setOtherLogoColorValue = () => {
    setOtherLogoColor(true)
    setLogoColor('')
  }

  const resetPromptCancel = () => {
    setCancelPrompt(false)
  }

  const resetPromptSubmit = () => {
    cancel()
  }

  const openResetPrompt = () => {
    setCancelPrompt(true)
  }

  const logoPromptCancel = () => {
    setWithoutLogo(false)
  }

  const logoPromptSubmit = () => {
    setWithoutLogo(false)
    visibleCard.current += 1
    setOpenContent(state => state + 1)
  }

  const onLogoChange = (files: any) => {
    setLogoFiles(files)
  }

  const onpriceMarginChange = (value: number | string) => {
    setpriceMargin(Number(value))
  }

  const next = () => {
    if (design === '') {
      setOpenContent(1)
      setIsError(true)
    } else if ((
      (logoFiles.length === 1 || logoFiles.length > 2) && design === 'design4')
      || (logoFiles.length >= 2 && design !== 'design4')) {
      setOpenContent(2)
    } else if(visibleCard.current === 4 && logoColor === '') {
      setIsError(true)
      setOpenContent(3)
    } else if (visibleCard.current === 4) {
      sendFiles('school', logoFiles, saveData, setIsLoading)
    } else if (openContent === 2) {
      if (!logoFiles.length && noLogoPrompt !== 'hideLogo') {
        setWithoutLogo(true)
        setNoLogoPrompt('hideLogo')
        window.localStorage.setItem('School-noLogoPrompt', 'hideLogo')
      } else {
        if (visibleCard.current !== 3) {
          visibleCard.current += 1
        }
        setOpenContent(state => state + 1)
      }
    } else if (
      (visibleCard.current >= 2 && visibleCard.current >= 2)
      && (
        (design !== 'design4' && logoFiles.length === 2)
        || (design === 'design4' && logoFiles.length === 1)
      )) {
      setOpenContent(2)
    } else if (visibleCard.current === 3 && logoColor === '') {
      setOpenContent(3)
      setIsError(true)
    } else if (visibleCard.current < 4) {
      setOpenContent(visibleCard.current + 1)
      visibleCard.current += 1
    }
  }

  const designModal = (
    <div className={styles.Options}>
      {Object.keys(schoolCloth[clothType].designTypes).map((item) => (
        <div className={`${styles.OptionWrapper} ${design === item && styles.Active}`} key={item} onClick={() => {
          setDesignValue(item)
        }}>
          <img src={schoolCloth[clothType].designTypes[item].img} alt={item} />
          <div>
          <FormattedMessage id={`Design.${schoolCloth[clothType].designTypes[item].title}`}/>
          </div>
        </div>
      ))}
    </div>
  )

  const logoColorModalContent = (
    <div className="static-wrapper">
      <div className={styles.LogoItemsWrapper}>
        {Object.keys(printColors).map((itemColor) => (
          <div key={itemColor}>
            <div
              className={styles.LogoColor}
              style={{
                backgroundColor: schoolCloth[clothType].colors[color],
                color: printColors[itemColor],
              }}
            >
              A
            </div>
            <div className={styles.LogoColorName}>
              <FormattedMessage id={`Color.${itemColor}`} />
            </div>
          </div>
        ))}
      </div>
      <div className="info-block">
        <h3><FormattedMessage id="LogoColorModal.info.title" /></h3>
        <p><FormattedMessage id="LogoColorModal.info.text" /></p>
        <a href="https://pantone-colours.com/" target="_blank" rel="noreferrer">https://wwww.pantone-colours.com/</a>
      </div>
    </div>
  )

  return (
    <ModalProvider>
      <TopSection
        title="SchoolShop.topSection.create.title"
        description="SchoolShop.topSection.create.description"
        hideMobile
      />
      <div className={styles.Wrapper}>
        <CloseBtn cancel={openResetPrompt} />
        <div className={styles.CardDescription}>
          <h3><FormattedMessage id={`ClothType.${clothType}`} /></h3>
          <p>
            <FormattedMessage
              id="UnionClothes.stage2.subtitle"
              values={{ product: intl.formatMessage({ id: `ClothType.${clothType}` }) }}
            />
          </p>
        </div>
        <Card
          title={'SchoolShop.stage3.title'}
          description={'SchoolShop.stage3.description'}
          value={`Color.${color}`}
          onContentOpen={() => {
            setOpenContent(0)
          }}
          hideContent={openContent !== 0}
        >
          <div className={styles.SelectColorWrapper}>
            <h2><FormattedMessage id={'SchoolShop.stage3.SelectColor'} /></h2>
            <div><FormattedMessage id={`Color.${color}`} /></div>
          </div>
          <div className={styles.ColorsWrapper}>
            {Object.keys(schoolCloth[clothType].colors).map((itemColor) => (
              <Tooltip
                placement="bottom"
                overlayInnerStyle={{
                  padding: '16px',
                  marginTop: '-5px',
                  color: '#3D3E43',
                  fontSize: '14px',
                  border: '1px solid #E9EAED',
                  borderRadius: '4px'
                }}
                overlay={<FormattedMessage id={`Color.${itemColor}`} />}
                key={itemColor}
              >
                <div className={`${styles.ColorContainer} ${color === itemColor && styles.Active}`}>
                  <div
                    className={styles.Color}
                    style={{ backgroundColor: schoolCloth[clothType].colors[itemColor] }}
                    onClick={() => {
                      setColor(itemColor)
                    }}
                  />
                </div>
              </Tooltip>
            ))}
          </div>
        </Card>
        <Card
          title={'SchoolShop.stage4.design.title'}
          description={'SchoolShop.stage4.design.description'}
          value={`Design.${design}`}
          discoverMore={designOptionsStaticContent}
          discoverMoreTitle="SchoolShop.stage4.design.modal.discoverMore.title"
          onContentOpen={() => {
            setOpenContent(1)
          }}
          hideContent={openContent !== 1}
        >
          <InputButton
            label="SchoolShop.stage4.modal.design.title"
            onClick={openModal}
            isError={isError && visibleCard.current === 1}
            errorLabel="SchoolShop.stage4.design.error"
          >
            {<FormattedMessage id={design ? `Design.${design}` : 'Design.placeholder'} />}
          </InputButton>
        </Card>
        {visibleCard.current >= 2 &&
          <Card
            title={'SchoolShop.stage4.logo.title'}
            warningMessage={'Overview.props.noLogo'}
            description={'SchoolShop.stage4.logo.description'}
            value={logoFiles.map((file: any) => file.name).join(', ')}
            discoverMore={logoStaticContent}
            discoverMoreTitle="SchoolShop.stage4.logo.modal.title"
            onContentOpen={() => {
              setOpenContent(2)
            }}
            hideContent={openContent !== 2}
          >
            <FileInput
              design={design}
              valueFiles={logoFiles}
              onChange={onLogoChange}
            />
          </Card>}
        {withoutLogo &&
          <Prompt
            title="SchoolShop.stage4.logoPrompt.title"
            text="SchoolShop.stage4.logoPrompt.text"
            cancel={logoPromptCancel}
            submit={logoPromptSubmit}
            submitText="continue"
            warning
          />
        }
        {cancelPrompt &&
          <Prompt
            title="SchoolShop.stage4.resetPrompt.title"
            text="SchoolShop.stage4.resetPrompt.text"
            cancel={resetPromptCancel}
            submit={resetPromptSubmit}
            submitText="continue"
          />
        }
        {visibleCard.current >= 3 &&
          <Card
            title={'SchoolShop.stage4.logoColor.title'}
            description={'SchoolShop.stage4.logoColor.description'}
            value={otherLogoColor ? logoColor : logoColor && `Color.${logoColor}`}
            discoverMore={logoColorModalContent}
            discoverMoreTitle="SchoolShop.stage4.logoColor.modal.title"
            onContentOpen={() => {
              setOpenContent(3)
            }}
            hideContent={openContent !== 3}
          >
            <div className={styles.SelectColorWrapper}>
              <h2><FormattedMessage id={'SchoolShop.stage3.SelectLogoColor'} /></h2>
              {(logoColor || otherLogoColor) && <div><FormattedMessage id={`Color.${otherLogoColor ? "special.pantone" : logoColor}`}/></div>}
            </div>
            <div className={styles.ColorsWrapper}>
              {Object.keys(printColors).map((itemColor) => (
                <Tooltip
                  placement="bottom"
                  overlayInnerStyle={{
                    padding: '16px',
                    marginTop: '-5px',
                    color: '#3D3E43',
                    fontSize: '14px',
                    border: '1px solid #E9EAED',
                    borderRadius: '4px'
                  }}
                  overlay={<FormattedMessage id={`Color.${itemColor}`} />}
                  key={itemColor}
                >
                  <div
                    className={`${styles.ColorContainer} ${logoColor === itemColor && styles.Active} ${isError && styles.Error}`}>
                    <div
                      className={styles.Color}
                      style={
                        { background: printColors[itemColor] }}
                      onClick={() => {
                        setOtherLogoColor(false)
                        setLogoColorValue(itemColor)
                      }}
                    />
                  </div>
                </Tooltip>
              ))}
              <Tooltip
                placement="bottom"
                overlayInnerStyle={{
                  padding: '16px',
                  marginTop: '-5px',
                  color: '#3D3E43',
                  fontSize: '14px',
                  border: '1px solid #E9EAED',
                  borderRadius: '4px'
                }}
                overlay={<FormattedMessage id={"Color.special.pantone"} />}
                key={"Color.other"}
              >
                <div className={`${styles.ColorContainer} ${otherLogoColor && styles.Active} ${isError && styles.Error}`}>
                  <div
                    className={styles.Color}
                    style={{ textAlign: 'center',
                              fontSize: '36px',
                              lineHeight: '20px',
                              letterSpacing: '.5px',
                              cursor: 'pointer',
                  }}
                    onClick={() => {
                      setOtherLogoColorValue()
                    }}
                  >...
                  </div>
                </div>
              </Tooltip>
            </div>

            {otherLogoColor &&
              <>
                <CustomInput
                  title={"Color.special.pantone"}
                  placeholder={"For example: PANTONE 185 C"}
                  value={logoColor}
                  type={"text"}
                  onChange={setLogoColorValue}
                />
                  <a className={styles.Link} href="http://www.pantone-colours.com/" target="_blank" rel="noreferrer">
                      <FormattedMessage id={"Color.customInput.link"} />
                  </a>
              </>
            }
            {
              otherLogoColor
                ? <div className={styles.OtherDescription}><FormattedMessage id={"Color.customInput.description"} /></div>
                : logoColor === 'multiColor' && <div className={styles.MultiColor}>
                    <p><FormattedMessage id={"Color.customInput.MultiColorPDF"}/></p>
                    <p><FormattedMessage id={"Color.customInput.MultiColorCost"}/></p>
                  </div>
            }

            {isError &&
              <div className={styles.ErrorText}>
                <FormattedMessage id={'SchoolShop.stage4.error.logoColor'} />
              </div>
            }

          </Card>}
        {visibleCard.current >= 4 &&
          <Card
            title={'SchoolShop.stage4.priceMargin.title'}
            description={'SchoolShop.stage4.priceMargin.description'}
            value={priceMargin > -1 ? `priceMargin.${priceMargin}` : 'SchoolShop.stage4.priceMargin.placeholder'}
            onContentOpen={() => {
              setOpenContent(4)
            }}
            hideContent={openContent !== 4}
          >
            <Select
              values={[0, 20]}
              onChange={onpriceMarginChange}
              postText={'currency'}
            >
              {priceMargin >= 0 ?
                <FormattedMessage id={`priceMargin.${priceMargin}`} />
                : <FormattedMessage id={'SchoolShop.stage4.priceMargin.placeholder'} />}
            </Select>
          </Card>}
      </div>

      <Button
        onClick={next}
        buttonDescription={isLoading ? 'loading' : visibleCard.current === 4 ? 'complete' : 'SchoolShop.stage2.button'}
        buttonColor
        center
      />

      <Modal title={
        openContent === 1
          ? 'SchoolShop.stage4.modal.design.title'
          : openContent === 3
            ? 'SchoolShop.stage4.modal.logotype.title'
            : ''
      }>
        {designModal}
      </Modal>
    </ModalProvider>
  )
}
